












































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import LoadingCursor from '@components/LoadingCursor'
import Modal from '@/components/Modal'
import WaitingModal from '@/components/WaitingModal'
import WizardService from '@services/Wizard'
import WizardRoutes from './routes'

settings =
  name: 'AudienceCreativeEditWizard'

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreativeId/edit'
    supplier_media_kit:
      resourceName: 'supplier_media_kit'
      slug: 'suppliers/:supplierId/media_kit'
    calendar_dates:
      resourceName: 'calendar_date'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreativeId/calendar_dates'
      params:
        quick_list: true
    spaces:
      resourceName: 'space'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreativeId/spaces'
      params:
        quick_list: true

  vue:
    props: ['options']
    mixins: [WizardService.wizard()]

    components: {
      LoadingIndicator,
      LoadingCursor,
      Modal,
      WaitingModal,
    }

    data: ->
      mode: 'EDIT'
      containerToScroll: null
      displayWaitingModal: false
      closeModal:
        show: false

    computed:
      member: -> @$store.member
      supplierId: -> @options?.supplierId || @member.supplier.id
      audienceCreativeData: -> @prime.audience_creative
      audienceCreativeErrors: -> @formErrors.audience_creative || {}
      creativeSpaces: -> @spaces || []

      wizardRoutes: -> WizardRoutes
      enabledRoutes: -> @wizardRoutes
      routeQuery: -> @$route.query

      mediaKits: ->
        supplier: @supplier_media_kit

    methods:
      hiClose: ->
        @closeModal.show = true

      hiConfirmClose: ->
        @$router.push({ name: 'AudienceCreativeListPage' })

      showWaitingModal: ->
        @displayWaitingModal = true

      hideWaitingModal: ->
        @displayWaitingModal = false

      finish: ->
        @hiConfirmClose()

      save: ->
        clearTimeout(@time)
        @time = setTimeout(() =>
          @saveItem('prime.audience_creative')
        , 300)

      saveField: (fieldName) ->
        @saveItemField('prime.audience_creative', fieldName, { skipFlash: true })

      saveAdvancedFields: (fieldNames) ->
        @saveField fieldNames

      onCollectionLoadItemCompleted: (resourceKey) ->
        return unless resourceKey is 'audience_creative'
        @wizard.navToStepName 'preview' if @activeStep.name is 'advanced-settings'

      fetchAudienceCreative: ->
        @fetch 'audience_creative'

      fetchMediaKits: ->
        @fetch 'supplier_media_kit'

      fetchCalendarDates: ->
        @fetch 'calendar_dates'

      fetchSpaces: ->
        @fetch 'spaces'

      unbindCalendarDatesFromAudienceCreative: (dates) ->
        @triggerResource 'audience_creative', 'unbind_dates', { calendar_date_ids: dates.map((d) => d.id) }
      onAudienceCreativeUnbindDates: ->
        @fetchCalendarDates()

      unbindSpacesFromCreative: (spaces, availabilities) ->
        payload =
          space_ids: spaces.map((s) => s.id)
          availability_ids: availabilities?.map((a) => a.id)
        @triggerResource 'audience_creative', 'unbind_spaces', payload
      onAudienceCreativeUnbindSpaces: ->
        @fetch 'audience_creative'

      bindVenuesToCreative: (venues) ->
        payload = { venue_ids: venues.map((s) => s.id) }
        @triggerResource 'audience_creative', 'bind_venues', payload
      onAudienceCreativeBindVenues: ->
        @fetch 'audience_creative'

      unbindVenuesFromCreative: (venues) ->
        payload = { venue_ids: venues.map((s) => s.id) }
        @triggerResource 'audience_creative', 'unbind_venues', payload
      onAudienceCreativeUnbindVenues: ->
        @fetch 'audience_creative'

      publishAllTrigger: ->
        @triggerResource 'audience_creative', 'publish_all'
      onAudienceCreativePublishAll: ->
        @finish()

      unpublishAllTrigger: ->
        @triggerResource 'audience_creative', 'unpublish_all'
      onAudienceCreativeUnpublishAll: ->
        @fetch 'audience_creative'

      addSuperNote: (note) ->
        @triggerResource 'audience_creative', 'add_super_note', { note }

      setContainerSelectorToScroll: (containerSelectorToScroll) ->
        @containerSelectorToScroll = containerSelectorToScroll

      scrollToHandler: ->
        if @containerSelectorToScroll
          intervalCount = 10
          intervalId = setInterval(() =>
            if document.querySelector(@containerSelectorToScroll)
              @scrollContainerTo '#dashboard', @containerSelectorToScroll
              @containerSelectorToScroll = null
              clearInterval intervalId
            else
              clearInterval intervalId if --intervalCount is 0
          , 200)
        else
          @scrollTo '#dashboard'

    watch:
      steps: ->
        @navToStepName @routeQuery.step, { skipSave: true } if @routeQuery.step?

      'wizard.activeStep.name': (step) ->
        return unless step and step isnt 'empty'
        @scrollToHandler()
        route = @wizardRoutes.find((route) => route.name is step)
        query = { ...@routeQuery, step } if route.hideOnNavbar
        query ||= { step }
        @$router.push { query }

      routeQuery: (query) ->
        @navToStepName query.step, { skipSave: true } if query.step?

export default VueOptions.vue settings
